const isNumeric = (value: string): boolean => /^\d+$/.test(value);

export default isNumeric;
